import * as React from 'react';
import * as PropTypes from 'prop-types';
import { classNames } from '@progress/kendo-react-common';
import { avatarType, avatarShape, avatarSize, avatarFill, avatarThemeColor } from './interfaces/Enums';
import { validatePackage } from '@progress/kendo-licensing';
import { packageMetadata } from '../package-metadata';
export var Avatar = function Avatar(props) {
  validatePackage(packageMetadata);
  return React.createElement("div", {
    style: props.style,
    className: classNames('k-avatar', "k-avatar-" + props.fill, "k-avatar-" + props.shape, "k-avatar-" + props.themeColor, {
      'k-avatar-bordered': props.border,
      'k-avatar-sm': props.size === 'small',
      'k-avatar-md': props.size === 'medium',
      'k-avatar-lg': props.size === 'large'
    }, props.className)
  }, React.createElement("span", {
    className: "k-avatar-" + props.type
  }, props.children));
};
Avatar.propTypes = {
  className: PropTypes.string,
  shape: PropTypes.oneOf(['circle', 'square', 'rounded', 'rectangle']),
  type: PropTypes.oneOf(['text', 'image', 'icon']),
  fill: PropTypes.oneOf(['solid', 'outline']),
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  themeColor: PropTypes.oneOf(['primary', 'secondary', 'tertiary', 'info', 'success', 'warning', 'error', 'dark', 'light', 'inverse', 'inherit'])
};
Avatar.defaultProps = {
  type: avatarType.TEXT,
  shape: avatarShape.SQUARE,
  size: avatarSize.MEDIUM,
  fill: avatarFill.SOLID,
  themeColor: avatarThemeColor.PRIMARY
};